
import { AssignTrackerDto, TrackerEntityType } from "../Shared/Telematics.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ColumnDefinition$1, CellContent } from "../Widgets/Table/Types.js";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { InfiniteTable } from "../Widgets/Table/InfiniteTable.js";
import { empty, ofArray, filter as filter_1, singleton, tryHead, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import Map_Location from "../../public/assets/icons/Map_Location.svg";
import { singleton as singleton_1, append, delay, toList, iterate } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { unwrap, orElse, toArray as toArray_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { TableControlElement$1, TableControl$1 } from "../Widgets/Table/Table.js";
import { SWR_getTools } from "../Requests/Tool.js";
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState__getValidation, FormState_get_empty } from "../Shared/Shared.js";
import { ModalSheet } from "../Components/ModalSheet.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ErrorAlert } from "../Components/Alert.js";
import { assignTracker } from "../Requests/Telematics.js";
import { toast } from "react-hot-toast";
import { Skeleton } from "../Components/Skeleton.js";

function testId(id) {
    return ["data-test-id", id];
}

function trackerEntityType(tool) {
    const matchValue = tool.ToolOverviewType;
    switch (matchValue) {
        case "set":
            return new TrackerEntityType(1, []);
        case "toolWithQuantity":
        case "consumable":
            return undefined;
        default:
            return new TrackerEntityType(0, []);
    }
}

function InventoryTable(props) {
    let TableRows, Options;
    const t = useTranslation()[0];
    const textColumn = (id, header, filter, value) => (new ColumnDefinition$1(id, "", header, (tool) => (new CellContent(0, [value(tool)])), filter, "text"));
    const columns = reactApi.useMemo(() => [textColumn("type", t("general.kind"), "select", (tool_1) => {
        const matchValue = trackerEntityType(tool_1);
        return (matchValue == null) ? "" : ((matchValue.tag === 1) ? t("general.set") : t("general.tool"));
    }), textColumn("displayName", t("tool.displayname"), "text", (tool_2) => tool_2.DisplayName), textColumn("manufacturer", t("tool.manufacturer"), "text", (tool_3) => tool_3.Manufacturer), textColumn("model", t("tool.model"), "text", (tool_4) => tool_4.Model), textColumn("inventoryNumber", t("tool.inventory_number"), "text", (tool_5) => tool_5.InventoryNumber), textColumn("serialNumber", t("tool.serial_number"), "text", (tool_6) => tool_6.SerialNumber), textColumn("storage", t("general.storage"), "select", (tool_7) => tool_7.Storage), textColumn("qrCodeIds", t("general.qr_code"), "text", (tool_8) => tool_8.QRCodeIds)], []);
    return createElement(InfiniteTable, (TableRows = toArray(props.Inventory), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["displayName", "asc"],
        Fullscreen: false,
        GlobalSearch: true,
        RowSelection: "singleRow",
        SaveTableConfiguration: false,
        WithQueryParameters: false,
    }, {
        ColumnDefinitions: columns,
        Controls: singleton(new TableControlElement$1(0, [new TableControl$1(t("telematics.assignment.assign"), Map_Location(), (rows) => {
            iterate(props.OnAssign, toArray_1(tryHead(rows)));
        }, true, true, "assign-tracker-confirm")])),
        Options: Options,
        TableKey: "assign-tracker-inventory",
        TableRows: TableRows,
    })));
}

export function AssignTrackerModalSheet(props) {
    let Title, elems;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const inventory = SWR_getTools();
    let patternInput_1;
    const initial = FormState_get_empty();
    patternInput_1 = reactApi.useState(initial);
    const setFormState = patternInput_1[1];
    const formState = patternInput_1[0];
    const validationMessage = orElse(FormState__getValidation(formState, t, "global"), FormState__getValidation(formState, t, "tracker_id"));
    return createElement(ModalSheet, (Title = t("telematics.assignment.assign_dialog_title"), {
        CloseButtonTestId: "assign-tracker-cancel",
        Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "px-4", "pb-4", "h-full"])], testId("assign-tracker-dialog"), (elems = toList(delay(() => {
            let arg_1;
            return append(singleton_1(reactElement("p", {
                className: join(" ", ["text-sm", "text-gray-600"]),
                children: (arg_1 = {
                    tracker: concat(props.Tracker.Name, " · ", ...props.Tracker.Imei),
                }, patternInput[1].t("telematics.assignment.assign_dialog_description", arg_1)),
            })), delay(() => {
                let matchValue_1;
                return append((matchValue_1 = validationMessage, (matchValue_1 == null) ? singleton_1(defaultOf()) : singleton_1(createElement(ErrorAlert, {
                    Label: matchValue_1,
                }))), delay(() => {
                    const matchValue_2 = inventory.data;
                    return (matchValue_2 != null) ? singleton_1(createElement(InventoryTable, {
                        Inventory: filter_1((arg_2) => (trackerEntityType(arg_2) != null), matchValue_2),
                        OnAssign: (tool) => {
                            let entityType;
                            const matchValue = trackerEntityType(tool);
                            let matchResult, entityType_1;
                            if (matchValue != null) {
                                if ((entityType = matchValue, !formState.IsLoading)) {
                                    matchResult = 0;
                                    entityType_1 = matchValue;
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                            switch (matchResult) {
                                case 0: {
                                    setFormState(FormState__startLoading(formState));
                                    let pr_2;
                                    let pr_1;
                                    const pr = assignTracker(entityType_1, tool.Id, new AssignTrackerDto(props.Tracker.TrackerId));
                                    pr_1 = (pr.then((response) => {
                                        let copyOfStruct;
                                        if (response.tag === 1) {
                                            setFormState((copyOfStruct = FormState_get_empty(), FormState__setValidationResponse_5219762A(copyOfStruct, response.fields[0])));
                                        }
                                        else {
                                            setFormState(FormState_get_empty());
                                            toast.success(t("telematics.assignment.assigned_toast"));
                                            props.OnAssigned();
                                            props.OnClose();
                                        }
                                    }));
                                    pr_2 = (pr_1.then(void 0, ((_arg) => {
                                        setFormState(FormState_get_empty());
                                        toast.error(t("telematics.assignment.assign_failed"));
                                    })));
                                    pr_2.then();
                                    break;
                                }
                                case 1: {
                                    break;
                                }
                            }
                        },
                    })) : ((inventory.error != null) ? singleton_1(createElement(ErrorAlert, {
                        Label: t("telematics.assignment.inventory_load_failed"),
                    })) : singleton_1(createElement(Skeleton, {
                        Variant: "table",
                    })));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])]))),
        Controls: empty(),
        IsModalOpen: true,
        OnClose: props.OnClose,
        Title: unwrap(Title),
    }));
}

